import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
export default class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.contents = document.getElementById('cart-notification');
    this.container = this.contents.querySelector('._container');

    this.isOpen = false;
    this.clearTimer;

    this.close = document.querySelectorAll('.f-miniCartModalClose');

    this.setup()
  }

  setup () {
    store.subscribe(((mutation, state) => {

      if(store.getters['miniCartModal']())
      {
        if(!this.isOpen)
        {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(function()
          {
            this.contents.focus();
          }.bind(this), 300);

          clearTimeout(this.clearTimer);
          this.clearTimer = setTimeout(function()
          {
            store.dispatch('setMiniCartModal', {
              sta: false
            });
          }.bind(this), 5000);
        }
      }
      else
      {
        if(this.isOpen)
        {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );
        }
      }
    }));

    this.close.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setMiniCartModal', {
          sta: false
        });
      });
    });
  }

  open() {
    store.dispatch('setMiniCartModal', {
      sta: true
    });
  }

  close() {
    store.dispatch('setMiniCartModal', {
      sta: false
    });
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
